'use client';

import { useGoogleAnalytics, useScrollDepthTracking } from '@/lib/analytics';

export default function GoogleAnalytics() {
  useGoogleAnalytics();
  useScrollDepthTracking();
  
  return null;
}